import { Avatar, Box, ToggleButton } from '@mui/material'
import React from 'react'
import { useFormContext } from 'react-hook-form'

const AvatarBoxButton = ({ loading, avatar, width, height }) => {
  const methods = useFormContext()
  const { register, setValue, formState: { errors } } = methods

  const avatarOnClickHandler = () => {
    setValue('avatarId', avatar.id)
    register('avatarId', { required: { value: avatar.id, message: 'Invalid Avatar' } })
  }

  if (!loading) {
    return (
      <ToggleButton value={avatar.id} key={avatar.avatarImageUrl} onClick={avatarOnClickHandler} sx={{ p: 0, border: 0 }}>
        <Box sx={{
          p: 3,
          border: '1px solid',
          borderColor: 'grey.800',
          bgcolor: '#222222',
          borderRadius: 5,
          m: 1,
          '&:hover': {
            backgroundColor: '#333'
          }
        }}>
          <Avatar alt="default avatars" sx={{ width, height }} src={avatar.avatarImageUrl} />
        </Box>
      </ToggleButton>
    )
  } else {
    return undefined
  }
}

export default AvatarBoxButton
